import type { SeoReportVisualSignalsContent } from './types'

export const VISUAL_SIGNALS_MIN_RADAR_PRODUCTS = 3
export const VISUAL_SIGNALS_MIN_RADAR_DIMENSIONS = 3
export const VISUAL_SIGNALS_MIN_SCATTER_POINTS = 3

export function hasVisualSignalsRadarPayload(
  content: SeoReportVisualSignalsContent | null | undefined
): boolean {
  return (
    (content?.dimensionComparison?.products.length ?? 0) >=
      VISUAL_SIGNALS_MIN_RADAR_PRODUCTS &&
    (content?.dimensionComparison?.dimensions.length ?? 0) >=
      VISUAL_SIGNALS_MIN_RADAR_DIMENSIONS
  )
}

export function hasVisualSignalsScatterPayload(
  content: SeoReportVisualSignalsContent | null | undefined
): boolean {
  return (
    (content?.pricePerformance?.points.length ?? 0) >=
    VISUAL_SIGNALS_MIN_SCATTER_POINTS
  )
}

export function hasVisualSignalsChartPayload(
  content: SeoReportVisualSignalsContent | null | undefined
): boolean {
  return (
    hasVisualSignalsRadarPayload(content) ||
    hasVisualSignalsScatterPayload(content)
  )
}
